import { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';
import html2canvas from 'html2canvas';
import { Image, Page } from '@react-pdf/renderer';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import IconDownArrow from '../../components/Icon/IconDownArrow';
import {
    usePostOrderDeleteMutation,
    usePostOrderByStatusMutation,
    usePostOrderSampleDeleteMutation,
    usePostOrderDetailEditMutation,
    usePostOrderStatusEditMutation,
    usePostSamplePdfUsedMutation,
    usePostUpdateUpsDetailMutation,
    usePostSentOrderCompleteEmailMutation,
} from '../../store/services/api';
import DashboardTableTop from './DashboardTableTop';
import DashboardTableData from './DashboardTableData';
import EditOrderDetailModal from './EditOrderDetailModal';
import { createShipmentAndLabel } from './UpsFunctions';
import CreateShipmentLabelModal from './CreateShipmentLabelModal';
import { boxLabelDataExcelExport, exportToExcelPending, glassLabelDataExcelExport } from './labelFunction';
import GeneralLabelModal from './generalLabelModal';
import PdfDownloadModal from '../Report/PdfDownloadModal';
import GeneralDetailModal from './GeneralDetailModal';
import CreateManuelShipmentLabelModal from './CreateManuelShipmentLabelModal';
import { chunkArray, getOrderListHtml } from '../../components/Dashboard/GeneralDashboardFunction';
import { getUser } from '../../store/slices/user';
import FormTextInputRow from '../../components/Form/FormTextInputRow';
import FormSelect from '../../components/Form/FormSelect';
import { SALE_TERRITORY_TYPE_CONSTANTS } from '../SampleReport/FormConstant';
import FormDatePicker from '../../components/Form/FormDatePicker';

const OrderDashboard = () => {

    const user = useSelector(getUser);
    const [isOrderPendingCollapse, setIsOrderPendingCollapse] = useState(false);
    const [isOrderInProductionCollapse, setIsOrderInProductionCollapse] = useState(false);
    const [isOrderReadyShippingCollapse, setIsOrderReadyShippingCollapse] = useState(false);
    const [isOrderShippingCollapse, setIsOrderShippingCollapse] = useState(false);
    const [isOrderCompleteCollapse, setIsOrderCompleteCollapse] = useState(false);

    const [pendingOrderPaginationIndex, setPendingOrderPaginationIndex] = useState(1);
    const [inProductionOrderPaginationIndex, setInProductionOrderPaginationIndex] = useState(1);
    const [readyShippingOrderPaginationIndex, setReadyShippingOrderPaginationIndex] = useState(1);
    const [shippingOrderPaginationIndex, setShippingOrderPaginationIndex] = useState(1);
    const [completedOrderPaginationIndex, setCompletedOrderPaginationIndex] = useState(1);

    const [maxPendingOrder, setMaxPendingOrder] = useState(0);
    const [maxInProductionOrder, setMaxInProductionOrder] = useState(0);
    const [maxReadyShippingOrder, setMaxReadyShippingOrder] = useState(0);
    const [maxShippingOrder, setMaxShippingOrder] = useState(0);
    const [maxCompletedOrder, setMaxCompletedOrder] = useState(0);

    const [pendingItems, setPendingItems] = useState([]);
    const [inProductionItems, setInProductionItems] = useState([]);
    const [readyShipmentItems, setReadyShipmentItems] = useState([]);
    const [shippingItems, setShippingItems] = useState([]);
    const [completedItems, setCompletedItems] = useState([]);

    const [isPendingLoading, setIsPendingLoading] = useState(true);
    const [isInProductionLoading, setIsInProductionLoading] = useState(false);
    const [isShippingReadyLoading, setIsShippingReadyLoading] = useState(false);
    const [isShippingLoading, setIsShippingLoading] = useState(false);
    const [isCompleteLoading, setIsCompleteLoading] = useState(false);

    const [orderDetailIndex, setOrderDetailIndex] = useState(-1);
    const [existingOrderStatus, setExistingOrderStatus] = useState('');

    const [isEditOrderDetailModalOpen, setIsEditOrderDetailModalOpen] = useState(false);
    const [orderEditData, setOrderEditData] = useState([]);
    const [orderSampleEditData, setOrderSampleEditData] = useState([]);
    const [orderEditId, setOrderEditId] = useState('');
    const [orderEditIsMetric, setOrderEditIsMetric] = useState(false);
    const [orderTrackingNumber, setOrderTrackingNumber] = useState([]);
    const [orderTrackingUrl, setOrderTrackingUrl] = useState([]);
    const [orderUpsLabelUrl, setOrderUpsLabelUrl] = useState([]);

    const [isGeneralDetailModalOpen, setIsGeneralDetailModalOpen] = useState(false);

    const [isGeneralLabelExportModalOpen, setIsGeneralLabelExportModalOpen] = useState(false);
    const [generalLabelModalData, setGeneralLabelModalData] = useState();
    const [generalLabelIsMetric, setGeneralLabelIsMetric] = useState(false);
    const [generalLabelOrderId, setGeneralLabelOrderId] = useState(0);

    const [isShipmentLabelDetailModalOpen, setIsShipmentLabelDetailModalOpen] = useState(false);
    const [isManuelShipmentLabelDetailModalOpen, setIsManuelShipmentLabelDetailModalOpen] = useState(false);

    const [orderTrigger] = usePostOrderByStatusMutation();
    const [orderDeleteTrigger] = usePostOrderDeleteMutation();
    const [sampleDeleteTrigger] = usePostOrderSampleDeleteMutation();
    const [editOrderDetailTrigger] = usePostOrderDetailEditMutation();
    const [editOrderStatusTrigger] = usePostOrderStatusEditMutation();
    const [editOrderPdfUsedTrigger] = usePostSamplePdfUsedMutation();
    const [updateUpsDetailsTrigger] = usePostUpdateUpsDetailMutation();
    const [orderCompletedEmailTrigger] = usePostSentOrderCompleteEmailMutation();

    const divRefs = useRef([]);
    const [pdfPageLayout, setPdfPageLayout] = useState([]);
    const [isDownloadModalOpen, setDownloadModalOpen] = useState(false);
    const [customPdfDiv, setCustomPdfDiv] = useState([]);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfTitle, setPdfTitle] = useState('pdfSample');

    const [isFilterCollapse, setIsFilterCollapse] = useState(false);
    const [isTerritoryDisable, setIsTerritoryDisable] = useState(false);
    const [customFilterValues, setCustomFilterValues] = useState({
        ownerEmail: '',
        territoryEmail: '',
        dispatchedDateFrom : '',
        dispatchedDateTo : '',
        orderNumber: '',
        customerName: '',
        projectName: '',
    });
    const formikCustomFilterValuesSchema = Yup.object().shape({
        ownerEmail: Yup.string(),
        territoryEmail: Yup.string(),
        dispatchedDateFrom : Yup.date(),
        dispatchedDateTo : Yup.date(),
        orderNumber: Yup.string(),
        customerName: Yup.string(),
        projectName: Yup.string(),
    });

    const checkAuth = () => {
        const arr = ['mschammel@viracon.com', 'kthiel@viracon.com', 'skeane@viracon.com', 'ccarlson@viracon.com', 'edeliguru@fenestrapro.com'];
        const str = user.email;

        const exists = arr.includes(str);

        if(!exists){
            toast.error("You are not authorized to perform this action. Please contact a Sales or Production Administrator for further support.");
        }

        return exists;
    }

    const getOrderByStatus = async (status) => {
        const config = {
            'Pending': {
                setLoading: setIsPendingLoading,
                paginationIndex: pendingOrderPaginationIndex,
                setItems: setPendingItems,
                setTotal: setMaxPendingOrder,
            },
            'In Production': {
                setLoading: setIsInProductionLoading,
                paginationIndex: inProductionOrderPaginationIndex,
                setItems: setInProductionItems,
                setTotal: setMaxInProductionOrder,
            },
            'Ready For Shipment': {
                setLoading: setIsShippingReadyLoading,
                paginationIndex: readyShippingOrderPaginationIndex,
                setItems: setReadyShipmentItems,
                setTotal: setMaxReadyShippingOrder,
            },
            'Shipping': {
                setLoading: setIsShippingLoading,
                paginationIndex: shippingOrderPaginationIndex,
                setItems: setShippingItems,
                setTotal: setMaxShippingOrder,
            },
            'Completed': {
                setLoading: setIsCompleteLoading,
                paginationIndex: completedOrderPaginationIndex,
                setItems: setCompletedItems,
                setTotal: setMaxCompletedOrder,
            }
        };

        const current = config[status];
        if (!current) return;

        current.setLoading(true);
        try {
            const dateCondition = new Date();
            dateCondition.setDate(dateCondition.getDate() - 4);
            const result = await orderTrigger({
                orderStatus: status,
                querySetting: { index: current.paginationIndex, customFilter: customFilterValues }
            });
            current.setItems(result.data.orderData);
            current.setTotal(result.data.totalItem);
        } finally {
            current.setLoading(false);
        }
    };

    const getDataWithPagination = async (status, newPaginationIndex) => {
        switch (status) {
            case 'Pending':
                await setPendingOrderPaginationIndex(pendingOrderPaginationIndex + newPaginationIndex);
                break;
            case 'In Production':
                setInProductionOrderPaginationIndex(inProductionOrderPaginationIndex + newPaginationIndex);
                break;
            case 'Ready For Shipment':
                setReadyShippingOrderPaginationIndex(readyShippingOrderPaginationIndex + newPaginationIndex)
                break;
            case 'Shipping':
                setShippingOrderPaginationIndex(shippingOrderPaginationIndex + newPaginationIndex)
                break;
            case 'Completed':
                setCompletedOrderPaginationIndex(completedOrderPaginationIndex + newPaginationIndex)
                break;
            default:
                break;
        }
    }

    useEffect( () => {
        if(isOrderPendingCollapse) {
            getOrderByStatus('Pending');
        }
    }, [isOrderPendingCollapse, pendingOrderPaginationIndex, customFilterValues]);

    useEffect( () => {
        if(isOrderInProductionCollapse){
            getOrderByStatus('In Production');
        }
    }, [isOrderInProductionCollapse, inProductionOrderPaginationIndex, customFilterValues]);

    useEffect( () => {
        if(isOrderReadyShippingCollapse){
            getOrderByStatus('Ready For Shipment');
        }
    }, [isOrderReadyShippingCollapse, readyShippingOrderPaginationIndex, customFilterValues]);

    useEffect( () => {
        if(isOrderShippingCollapse){
            getOrderByStatus('Shipping');
        }
    }, [isOrderShippingCollapse, shippingOrderPaginationIndex, customFilterValues]);

    useEffect( () => {
        if (isOrderCompleteCollapse) {
            getOrderByStatus('Completed');
        }
    }, [isOrderCompleteCollapse, completedOrderPaginationIndex, customFilterValues]);

    const handleOrderStatus = async (currentStatus, newUpdatedStatus, orderIndex, orderId) => {

        if(currentStatus !== 'Pending' || newUpdatedStatus !== 'In Production') {
            if (!checkAuth()) return; // Auth check
        }

        function orderStatusAssign(newData) {
            switch (newUpdatedStatus) {
                case 'Pending':
                    setPendingItems([{...newData, status: 'Pending'}, ...pendingItems]);
                    break;
                case 'In Production':
                    setInProductionItems([{...newData, status: 'In Production'}, ...inProductionItems]);
                    break;
                case 'Ready For Shipment':
                    setReadyShipmentItems([{...newData, status: 'Ready For Shipment'}, ...readyShipmentItems]);
                    break;
                case 'Shipping':
                    setShippingItems([{...newData, status: 'Shipping'}, ...shippingItems]);
                    break;
                case 'Completed':
                    setCompletedItems([{...newData, status: 'Completed'}, ...completedItems]);
                    break;
                default:
                    break;
            }
        }

        const result = await editOrderStatusTrigger({id: orderId, credentials: {newStatus: newUpdatedStatus}});

        if (result.data) {
            switch (currentStatus) {
                case 'Pending':
                    orderStatusAssign(pendingItems[orderIndex])
                    setPendingItems((prevData) => prevData.filter((item) => item.id !== pendingItems[orderIndex].id));
                    break;
                case 'In Production':
                    orderStatusAssign(inProductionItems[orderIndex]);
                    setInProductionItems((prevData) => prevData.filter((item) => item.id !== inProductionItems[orderIndex].id));
                    break;
                case 'Ready For Shipment':
                    orderStatusAssign(readyShipmentItems[orderIndex]);
                    setReadyShipmentItems((prevData) => prevData.filter((item) => item.id !== readyShipmentItems[orderIndex].id));
                    break;
                case 'Shipping':
                    orderStatusAssign(shippingItems[orderIndex]);
                    setShippingItems((prevData) => prevData.filter((item) => item.id !== shippingItems[orderIndex].id));
                    break;
                case 'Completed':
                    orderStatusAssign(completedItems[orderIndex]);
                    setCompletedItems((prevData) => prevData.filter((item) => item.id !== completedItems[orderIndex].id));
                    break;
                default:
                    break;
            }
            toast.success('Status Changed Successful!');
        } else {
            toast.error('Status Change Failed!');
        }
    }

    const orderDetailOpenHandler = (currentStatus, orderIndex) => {
        switch (currentStatus) {
            case 'Pending':
                setExistingOrderStatus('Pending');
                break;
            case 'In Production':
                setExistingOrderStatus('In Production');
                break;
            case 'Ready For Shipment':
                setExistingOrderStatus('Ready For Shipment');
                break;
            case 'Shipping':
                setExistingOrderStatus('Shipping');
                break;
            case 'Completed':
                setExistingOrderStatus('Completed');
                break;
            default:
                break;
        }

        setOrderDetailIndex(orderIndex);
    }

    const deleteSampleHandle = async (currentStatus, orderIndex, sampleIndex) => {
        if (currentStatus === 'Pending') {
            const result = await sampleDeleteTrigger([pendingItems[orderIndex].id, sampleIndex]);
            setPendingItems((prevData) =>
                prevData.map(order =>
                    order.id === pendingItems[orderIndex].id
                        ? { ...order, sampleData: order.sampleData.filter((_, index) => index !== sampleIndex) }
                        : order
                )
            );
            result.data ? toast.success('Sample Deleted Successfully!') : toast.error('Sample Delete Failed!');
        }
    }

    const handleOrderDelete = async (currentStatus, orderId) => {
        const itemToDelete = pendingItems.filter(element => element.orderId === orderId)[0];
        const result = await orderDeleteTrigger(itemToDelete.id);
        setPendingItems((prevData) => prevData.filter((item) => item.id !== itemToDelete.id));
        result.data ? toast.success('Order Deleted Successfully!') : toast.error('Order Delete Failed!');
    }

    const editOrderModalOpenHandler = (currentStatus, index) => {
        setExistingOrderStatus(currentStatus);
        setOrderDetailIndex(index);

        switch (currentStatus) {
            case 'Pending':
                setOrderSampleEditData(pendingItems[index].sampleData);
                setOrderEditData(pendingItems[index].formData);
                setOrderEditId(pendingItems[index].id);
                setOrderEditIsMetric(pendingItems[index].isMetric);
                setIsEditOrderDetailModalOpen(true);
                break;
            case 'In Production':
                setOrderSampleEditData(inProductionItems[index].sampleData);
                setOrderEditData(inProductionItems[index].formData);
                setOrderEditId(inProductionItems[index].id);
                setOrderEditIsMetric(inProductionItems[index].isMetric);
                setIsGeneralDetailModalOpen(true);
                break;
            case 'Ready For Shipment':
                setOrderSampleEditData(readyShipmentItems[index].sampleData);
                setOrderEditData(readyShipmentItems[index].formData);
                setOrderEditId(readyShipmentItems[index].id);
                setOrderEditIsMetric(readyShipmentItems[index].isMetric);
                setIsGeneralDetailModalOpen(true);
                break;
            case 'Shipping':
                setOrderSampleEditData(shippingItems[index].sampleData);
                setOrderEditData(shippingItems[index].formData);
                setOrderEditId(shippingItems[index].id);
                setOrderEditIsMetric(shippingItems[index].isMetric);
                setIsEditOrderDetailModalOpen(true);
                break;
            case 'Completed':
                setOrderSampleEditData(completedItems[index].sampleData);
                setOrderEditData(completedItems[index].formData);
                setOrderEditId(completedItems[index].id);
                setOrderEditIsMetric(completedItems[index].isMetric);
                setOrderTrackingNumber(completedItems[index].trackingNumbers);
                setOrderTrackingUrl(completedItems[index].trackingURL);
                setOrderUpsLabelUrl(completedItems[index].labelURL)
                setIsGeneralDetailModalOpen(true);
                break;
            default:
                break;
        }
    }

    const orderEditUpdateFunction = async (updateData, updateId) => {
        if(existingOrderStatus !== 'Pending') {
            if (!checkAuth()) return; // Auth check
        }
        const result = await editOrderDetailTrigger({ id: updateId, credentials: updateData });
        if(result.data) {
            setPendingItems((prevData) =>
                prevData.map(order =>
                    order.id === updateId
                        ? { ...order, formData: updateData }
                        : order
                )
            );
            toast.success('Edit Successful!');
        } else {
            toast.error('Edit Failed!')
        }
    }

    const orderSampleDetailEditFunction = async (sampleIndex, editFields, updateId) => {
        if (existingOrderStatus !== 'Pending') {
            if (!checkAuth()) return;
        }
        setPendingItems((prevData) =>
            prevData.map(order => {
                if (order.id === updateId) {
                    const updatedSampleData = order.sampleData.map((sample, idx) =>
                        idx === sampleIndex
                            ? { ...sample, quantity: editFields.quantity, sampleSize: editFields.sampleSize }
                            : sample
                    );
                    return { ...order, sampleData: updatedSampleData };
                }
                return order;
            })
        );
    };

    const handleCreateShipmentLabel = async (boxDetails ,orderId) => {
        const orderToShip = shippingItems.filter(element => element.orderId === orderId)[0];
        const orderToShipIndex = shippingItems.findIndex(element => element.orderId === orderId);
        const parcel = [];

        if (orderToShip.formData.shipmentDestination === "International") {
            toast.error('International shipment should be completed manually.');
            return;
        }

        boxDetails.forEach((item) => {
            if(item.weight === "0"){
                toast.error('Weight cannot be 0. Please enter a valid box weight.');
                return;
            }
            parcel.push(
                {
                    length: item.length,
                    width: item.width,
                    height: item.height,
                    distanceUnit: 'in',
                    weight: item.weight,
                    massUnit: 'lb'
                }
            )
        })

        const addressFrom  = {
            name: "Viracon",
            street1: "800 Park Dr",
            city: "Owatonna",
            state: "MN ",
            zip: "55060",
            country: "US"
        };

        let addressTo = {};

        if(orderToShip) {

            if (orderToShip.formData.shipmentDestination === "Domestic") {
                addressTo = {
                    company: orderToShip.formData.ShipToCustomerName,
                    name: orderToShip.formData.shipToContactName,
                    street1: orderToShip.formData.shipmentAddress,
                    street2: orderToShip.formData.shipmentAddress2,
                    city: orderToShip.formData.shipmentCity,
                    state: orderToShip.formData.shipmentState,
                    zip: orderToShip.formData.shipmentPostcode,
                    phone: orderToShip.formData.shipToCustomerPhone,
                    country: "US",
                };

                const results = await Promise.all(
                    parcel.map(item => createShipmentAndLabel(addressFrom, addressTo, item))
                );

                const trackingNumbers = [];
                const trackingURL = [];
                const labelURL = [];
                let isLabelSuccessful = false;

                results.forEach((result, index) => {
                    if(result.status === 'SUCCESS') {
                        isLabelSuccessful = true;
                        trackingNumbers.push(result.trackingNumber);
                        trackingURL.push(result.trackingUrlProvider);
                        labelURL.push(result.labelUrl);
                        window.open(result.labelUrl, "_blank");
                    } else {
                        toast.error('Related error will be displayed here');
                    }
                });

                if(isLabelSuccessful) {
                    await orderCompletedEmailTrigger({
                        ownerEmail: orderToShip.formData.ownerEmail,
                        territoryEmail: orderToShip.formData.territoryEmail,
                        orderId: orderToShip.orderId,
                        trackingNumbers,
                        trackingURL
                    })

                    const updateResult = await updateUpsDetailsTrigger({
                        orderId: orderToShip.id,
                        trackingNumbers,
                        trackingURL,
                        labelURL
                    });

                    if(updateResult.data) {
                        await handleOrderStatus('Shipping', 'Completed', orderToShipIndex ,orderToShip.id);
                        setIsShipmentLabelDetailModalOpen(false);
                    }
                }
            }

        } else {
            toast.error('There is a problem in order address please try again.');
        }
    }

    const handleManuelCreateShipmentLabel = async (boxDetails, orderId) => {
        const orderToShip = shippingItems.filter(element => element.orderId === orderId)[0];
        const orderToShipIndex = shippingItems.findIndex(element => element.orderId === orderId);
        const trackingNumbers = [];
        const trackingURL = [];
        const labelURL = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const item of boxDetails) {
            if (item.trackingNumber === '') {
                toast.error('Tracking number not provided!');
                return;
            }

            trackingNumbers.push(item.trackingNumber);
            trackingURL.push(
                `https://wwwapps.ups.com/WebTracking/track?HTMLVersion=5.0&loc=en_US&Requester=UPSHome&WBPM_lid=homepage%2Fct1.html_pnl_trk&track.x=Track&trackNums=${item.trackingNumber}`
            );
            labelURL.push('');
        }

        const updateResult = await updateUpsDetailsTrigger({
            orderId: orderToShip.id,
            trackingNumbers,
            trackingURL,
            labelURL
        });

        await orderCompletedEmailTrigger({
            ownerEmail: orderToShip.formData.ownerEmail,
            territoryEmail: orderToShip.formData.territoryEmail,
            orderId: orderToShip.orderId,
            trackingNumbers,
            trackingURL
        })

        if(updateResult.data) {
            await handleOrderStatus('Shipping', 'Completed', orderToShipIndex ,orderToShip.id);
            setIsShipmentLabelDetailModalOpen(false);
        }
    }

    const handleCreatePendingExcelDetail = async (orderId) => {
        const data = pendingItems.filter(element => element.id === orderId)[0];
        await exportToExcelPending(data);
    }

    const handleGeneralLabelExport = async (orderId) => {
        if (!checkAuth()) return; // Auth check
        const data = readyShipmentItems.filter(element => element.id === orderId)[0];
        setGeneralLabelModalData(data.sampleData);
        setGeneralLabelIsMetric(data.isMetric);
        setGeneralLabelOrderId(data.orderId);
        setIsGeneralLabelExportModalOpen(true);
    }

    const handleShipmentLabelCreation = async (orderId) => {
        if (!checkAuth()) return; // Auth check
        const data = shippingItems.filter(element => element.id === orderId)[0];
        setGeneralLabelOrderId(data.orderId);
        setIsShipmentLabelDetailModalOpen(true);
    }

    const handleManuelShipmentLabelCreation = async (orderId) => {
        if (!checkAuth()) return; // Auth check
        const data = shippingItems.filter(element => element.id === orderId)[0];
        setGeneralLabelOrderId(data.orderId);
        setIsManuelShipmentLabelDetailModalOpen(true);
    }

    useEffect(() => {
        if (customPdfDiv.length > 0) {
            const generateImages = async () => {
                try {
                    const refsArray = divRefs.current;

                    // Run html2canvas on all refs in parallel
                    const canvases = await Promise.all(
                        refsArray
                            .filter(ref => ref !== null)
                            .map(ref => html2canvas(ref, { scale: 3 }))
                    );

                    const tmpImageList = canvases.map(canvas => canvas.toDataURL());

                    const tmpPdfPageLayout = tmpImageList.map(item => (
                        <Page key={item} size="A4" wrap={false}>
                            <Image src={item} />
                        </Page>
                    ));

                    setPdfPageLayout(tmpPdfPageLayout);
                    setDownloadModalOpen(true);

                    setTimeout(() => {
                        setPdfLoading(false);
                    }, 1000);
                } catch (error) {
                    toast.error("Unexpected error happened please try again!");
                    setPdfLoading(false);
                }
            };

            generateImages();
        }
    }, [customPdfDiv]);

    const generateOrderPdf = async (orderId, status) => {
        try {
            setPdfLoading(true);
            let data;

            switch (status) {
                case 1:
                    [data] = pendingItems.filter(element => element.orderId === orderId);
                    break;
                case 2:
                    [data] = inProductionItems.filter(element => element.orderId === orderId);
                    break;
                case 5:
                    [data] = completedItems.filter(element => element.orderId === orderId);
                    break;
                default:
                    break;
            }

            const currentDate = new Date().toDateString();
            setPdfTitle(`SA${data.orderId}${data.isRevised ? 'R' : ''}_${data.formData.customerName}_${data.formData.projectName}_${currentDate}`);
            const tmpCustomPdfDiv = [];
            const chunkedArray = chunkArray(data.sampleData, 2);

            chunkedArray.forEach((item, index) => {
                tmpCustomPdfDiv.push(getOrderListHtml(item, [], [], index, data, divRefs));
            });
            setCustomPdfDiv(tmpCustomPdfDiv);
        } catch (error) {
            toast.error('Unexpected error happened please try again!');
            setPdfLoading(false);
        };
    }

    const pdfUsedHandleFunction = async (orderId, status) => {
        if(status !==1) {
            const data = inProductionItems.filter(element => element.orderId === orderId)[0];
            await editOrderPdfUsedTrigger([data.id, {
                newValue: data?.pdfUsed !== undefined ? !data.pdfUsed : true,
            }]);
            setInProductionItems(prevItems =>
                prevItems.map(item =>
                    item.id === data.id ? { ...item, pdfUsed: data?.pdfUsed !== undefined ? !data.pdfUsed : true } : item
                )
            );
        }
    }

    const handleShipmentExports = async (lineValues, boxValues, orderId) => {
        try {
            setPdfLoading(true);
            const data = readyShipmentItems.filter(element => element.orderId === orderId)[0];
            const dataIndex = readyShipmentItems.findIndex(element => element.orderId === orderId);
            const tmpCustomPdfDiv = [];
            const chunkedArray = chunkArray(data.sampleData, 2);

            chunkedArray.forEach((item, index) => {
                tmpCustomPdfDiv.push(getOrderListHtml(item, lineValues, boxValues, index, data, divRefs));
            });
            setCustomPdfDiv(tmpCustomPdfDiv);

            await boxLabelDataExcelExport(data, lineValues, boxValues);
            await glassLabelDataExcelExport(data, lineValues);

            const refsArray = divRefs.current;
            const tmpImageList = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const ref of refsArray) {
                // eslint-disable-next-line no-await-in-loop
                await html2canvas(ref, {scale: 3 }).then(canvas => {
                    tmpImageList.push(canvas.toDataURL());
                });
            }

            const tmpPdfPageLayout = [];

            tmpImageList.forEach((item) => {
                tmpPdfPageLayout.push(
                    <Page size="A4" wrap={false}>
                        {item && (
                            <Image
                                src={item}
                            />
                        )}
                    </Page>
                )
            });
            setPdfPageLayout(tmpPdfPageLayout);
            setDownloadModalOpen(true);
            await handleOrderStatus('Ready For Shipment', 'Shipping', dataIndex ,data.id);
            setTimeout(() => {
                setPdfLoading(false);
            }, 1000);
        } catch (error) {
            toast.error('Unexpected error happened please try again!');
            setPdfLoading(false);
        };
    }

    const closeAllTabs = () => {
        setIsOrderPendingCollapse(false);
        setIsOrderInProductionCollapse(false);
        setIsOrderReadyShippingCollapse(false);
        setIsOrderShippingCollapse(false);
        setIsOrderCompleteCollapse(false);
    };

    const openAllTabs = () => {
        setIsOrderPendingCollapse(true);
        setIsOrderInProductionCollapse(true);
        setIsOrderReadyShippingCollapse(true);
        setIsOrderShippingCollapse(true);
        setIsOrderCompleteCollapse(true);
    };

    const reset = async () => {
        setCustomFilterValues({
            ownerEmail: '',
            territoryEmail: '',
            dispatchedDateFrom: '',
            dispatchedDateTo: '',
            orderNumber: '',
            customerName: '',
            projectName: '',
        });
    }

    const searchWithCustomFilter = async (formData) => {
        closeAllTabs();
        setCustomFilterValues(formData);
        openAllTabs();
    }

    return (
        <section className="h-[calc(100vh_-_2rem)] w-full bg-transparent p-4 rounded">
            {pdfLoading &&
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                    <div className="inline-block animate-spin ease-linear rounded-full border-t-4 border-blue-500 border-solid h-12 w-12" />
                    <p className="mt-2 text-blue-500">Please wait until PDF is created...</p>
                </div>}

            {!pdfLoading &&
                <div className="flex flex-col h-full w-full">

                    {/* Custom Filter Starts */}
                    <div className="flex flex-row w-full pb-4">
                        <button
                            type="button"
                            className="flex flex-row p-2 font-normal bg-[#137cc0] rounded w-40"
                            onClick={() => setIsFilterCollapse(!isFilterCollapse)}
                        >
                            <div className="flex flex-row justify-between w-full text-white">
                                <h2 className="font-bold">Custom Filter</h2>
                                <IconDownArrow />
                            </div>
                        </button>

                        <button
                            type="button"
                            className="ml-2 flex flex-row p-2 font-normal bg-[#137cc0] rounded w-40"
                            onClick={() => reset()}
                        >
                            <div className="flex flex-row justify-center w-full text-white">
                                <h2 className="font-bold">Reset</h2>
                            </div>
                        </button>
                    </div>

                    <div  className={isFilterCollapse ? 'w-full h-auto' : 'h-0 invisible'}>
                        <div className="flex flex-row w-full ">
                            <Formik
                                // eslint-disable-next-line react/jsx-boolean-value
                                enableReinitialize={true}
                                initialValues={customFilterValues}
                                validationSchema={formikCustomFilterValuesSchema}
                                onSubmit={searchWithCustomFilter}
                            >
                                {({ handleSubmit }) => (
                                    <Form className="flex flex-row w-full h-full gap-2 py-4 items-center justify-start" onSubmit={handleSubmit}>
                                        <div className="flex flex-col w-3/12 justify-between">
                                            <FormTextInputRow name="orderNumber" label='Order #:' />
                                            <FormTextInputRow name="ownerEmail" label='Owner Email:' />
                                            <FormSelect
                                                name="territoryEmail"
                                                label='Sale Territory:'
                                                placeholder="Select Sale Territory"
                                                options={SALE_TERRITORY_TYPE_CONSTANTS.map((element) => ({
                                                    key: element.id,
                                                    value: element.email,
                                                    extraIdentifier: element.name
                                                }))}
                                                isDisable={isTerritoryDisable}
                                            />
                                            <FormTextInputRow name="customerName" label="Customer Name:"/>
                                            <FormTextInputRow name="projectName" label="Project Name:"/>
                                            <FormDatePicker name="dispatchedDateFrom" label='Start Date:' />
                                            <FormDatePicker name="dispatchedDateTo" label='End Date:' />
                                            <div className="flex flex-row w-full h-12 text-[#3C3C3C] text-[11px] justify-end">
                                                <button
                                                    type="submit"
                                                    id='2'
                                                    className="w-40 pl-2 pr-2 mt-1 border-2 border-slate-300 rounded bg-slate-100 text-[11px] text-black font-bold"
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                    {/* Custom Filter End */}

                    {/* Order Pending Starts */}
                    <button
                        type="button"
                        className="flex flex-row p-2 font-normal bg-[#137cc0] rounded"
                        onClick={() => setIsOrderPendingCollapse(!isOrderPendingCollapse)}
                    >
                        <div className="flex flex-row justify-between w-full text-white">
                            <h2 className="font-bold">Orders Pending</h2>
                            <IconDownArrow />
                        </div>
                    </button>

                    <div  className={isOrderPendingCollapse ? 'h-auto' : 'h-0 invisible'}>
                        <DashboardTableTop />
                        {pendingItems.length === 0 && <div className="flex flex-row w-full items-center justify-center mt-8"><h2>There is no Pending Item</h2></div>}
                        {isPendingLoading &&
                            <div className="flex flex-col w-full text-center items-center justify-center p-4">
                                <div className="animate-spin ease-linear rounded-full border-t-4 border-blue-500 border-solid h-12 w-12" />
                                <p className="mt-2 text-blue-500">Please wait loading...</p>
                            </div>
                        }
                        {!isPendingLoading &&
                            <DashboardTableData
                                data={pendingItems}
                                orderDeleteHandleFunction={handleOrderDelete}
                                orderStatusHandleFunction={handleOrderStatus}
                                orderEditHandleFunction={editOrderModalOpenHandler}
                                currentStatus="Pending"
                                currentPage={pendingOrderPaginationIndex}
                                dataSize={maxPendingOrder}
                                requestDataFunction={getDataWithPagination}
                                requestExcelFunction={handleCreatePendingExcelDetail}
                                requestOnlyPdfFunction={generateOrderPdf}
                            />
                        }
                    </div>
                    {/* Order Pending Ends */}

                    {/* In production Starts */}
                    <button
                        type="button"
                        className="flex flex-row p-2 font-normal bg-[#fc9f70] rounded mt-4"
                        onClick={() => setIsOrderInProductionCollapse(!isOrderInProductionCollapse)}
                    >
                        <div className="flex flex-row justify-between w-full text-white">
                            <h2 className="font-bold">In Production</h2>
                            <IconDownArrow />
                        </div>
                    </button>

                    <div  className={isOrderInProductionCollapse ? 'h-auto' : 'h-0 invisible'}>
                        <DashboardTableTop />
                        {inProductionItems.length === 0 && <div className="flex flex-row w-full items-center justify-center mt-8"><h2>There is no In Production Item</h2></div>}
                        {isInProductionLoading &&
                            <div className="flex flex-col w-full text-center items-center justify-center p-4">
                                <div className="animate-spin ease-linear rounded-full border-t-4 border-blue-500 border-solid h-12 w-12" />
                                <p className="mt-2 text-blue-500">Please wait loading...</p>
                            </div>
                        }
                        {!isInProductionLoading &&
                            <DashboardTableData
                                data={inProductionItems}
                                orderStatusHandleFunction={handleOrderStatus}
                                orderDetailHandleFunction={orderDetailOpenHandler}
                                orderEditHandleFunction={editOrderModalOpenHandler}
                                currentStatus="In Production"
                                currentPage={inProductionOrderPaginationIndex}
                                dataSize={maxInProductionOrder}
                                requestDataFunction={getDataWithPagination}
                                requestOnlyPdfFunction={generateOrderPdf}
                                pdfUsedHandleFunction={pdfUsedHandleFunction}
                            />
                        }
                    </div>
                    {/* In production Ends */}

                    {/* Ready For Shipment Starts */}
                    <button
                        type="button"
                        className="flex flex-row p-2 font-normal bg-[#c96e37] rounded mt-4"
                        onClick={() => setIsOrderReadyShippingCollapse(!isOrderReadyShippingCollapse)}
                    >
                        <div className="flex flex-row justify-between w-full text-white">
                            <h2 className="font-bold">Ready For Shipment</h2>
                            <IconDownArrow />
                        </div>
                    </button>
                    <div  className={isOrderReadyShippingCollapse ? 'h-auto' : 'h-0 invisible'}>
                        <DashboardTableTop />
                        {readyShipmentItems.length === 0 && <div className="flex flex-row w-full items-center justify-center mt-8"><h2>There is no Ready to Shipment Item</h2></div>}
                        {isShippingReadyLoading &&
                            <div className="flex flex-col w-full text-center items-center justify-center p-4">
                                <div className="animate-spin ease-linear rounded-full border-t-4 border-blue-500 border-solid h-12 w-12" />
                                <p className="mt-2 text-blue-500">Please wait loading...</p>
                            </div>
                        }
                        {!isShippingReadyLoading &&
                            <DashboardTableData
                                data={readyShipmentItems}
                                orderStatusHandleFunction={handleOrderStatus}
                                orderDetailHandleFunction={orderDetailOpenHandler}
                                orderEditHandleFunction={editOrderModalOpenHandler}
                                requestGeneralLabel={handleGeneralLabelExport}
                                currentStatus="Ready For Shipment"
                                currentPage={readyShippingOrderPaginationIndex}
                                dataSize={maxReadyShippingOrder}
                                requestDataFunction={getDataWithPagination}
                            />
                        }
                    </div>
                    {/* Ready For Shipment Ends */}

                    {/* Shipping Starts */}
                    <button
                        type="button"
                        className="flex flex-row p-2 font-normal bg-[#8a77a6] rounded mt-4"
                        onClick={() => setIsOrderShippingCollapse(!isOrderShippingCollapse)}
                    >
                        <div className="flex flex-row justify-between w-full text-white">
                            <h2 className="font-bold">Shipping</h2>
                            <IconDownArrow />
                        </div>
                    </button>
                    <div  className={isOrderShippingCollapse ? 'h-auto' : 'h-0 invisible'}>
                        <DashboardTableTop />
                        {shippingItems.length === 0 && <div className="flex flex-row w-full items-center justify-center mt-8"><h2>There is no Shipping Item</h2></div>}
                        {isShippingLoading &&
                            <div className="flex flex-col w-full text-center items-center justify-center p-4">
                                <div className="animate-spin ease-linear rounded-full border-t-4 border-blue-500 border-solid h-12 w-12" />
                                <p className="mt-2 text-blue-500">Please wait loading...</p>
                            </div>
                        }
                        {!isShippingLoading &&
                            <DashboardTableData
                                data={shippingItems}
                                orderStatusHandleFunction={handleOrderStatus}
                                orderDetailHandleFunction={orderDetailOpenHandler}
                                orderEditHandleFunction={editOrderModalOpenHandler}
                                currentStatus="Shipping"
                                currentPage={shippingOrderPaginationIndex}
                                dataSize={maxShippingOrder}
                                requestDataFunction={getDataWithPagination}
                                createShipmentLabelFunction={handleShipmentLabelCreation}
                                createManuelShipmentLabelFunction={handleManuelShipmentLabelCreation}
                            />
                        }
                    </div>
                    {/* Shipping Ends */}

                    {/* Completed Starts */}
                    <button
                        type="button"
                        className="flex flex-row p-2 font-normal bg-[#81b471] rounded mt-4"
                        onClick={() => setIsOrderCompleteCollapse(!isOrderCompleteCollapse)}
                    >
                        <div className="flex flex-row justify-between w-full text-white">
                            <h2 className="font-bold">Completed</h2>
                            <IconDownArrow />
                        </div>
                    </button>
                    <div  className={isOrderCompleteCollapse ? 'h-auto' : 'h-0 invisible'}>
                        <DashboardTableTop />
                        {completedItems.length === 0 && <div className="flex flex-row w-full items-center justify-center mt-8"><h2>There is no Completed Item</h2></div>}
                        {isCompleteLoading &&
                            <div className="flex flex-col w-full text-center items-center justify-center p-4">
                                <div className="animate-spin ease-linear rounded-full border-t-4 border-blue-500 border-solid h-12 w-12" />
                                <p className="mt-2 text-blue-500">Please wait loading...</p>
                            </div>
                        }
                        {!isCompleteLoading &&
                            <DashboardTableData
                                data={completedItems}
                                orderStatusHandleFunction={handleOrderStatus}
                                orderDetailHandleFunction={orderDetailOpenHandler}
                                orderEditHandleFunction={editOrderModalOpenHandler}
                                currentStatus="Completed"
                                currentPage={completedOrderPaginationIndex}
                                dataSize={maxCompletedOrder}
                                requestDataFunction={getDataWithPagination}
                                requestOnlyPdfFunction={generateOrderPdf}
                            />
                        }
                    </div>
                    {/* Completed Ends */}
                </div>
            }

            {customPdfDiv}

            {isEditOrderDetailModalOpen &&
                <EditOrderDetailModal
                    onClose={() => setIsEditOrderDetailModalOpen(false)}
                    open={isEditOrderDetailModalOpen}
                    data={orderEditData}
                    isMetric={orderEditIsMetric}
                    sampleData={orderSampleEditData}
                    updateFunction={orderEditUpdateFunction}
                    updateSampleFunction={orderSampleDetailEditFunction}
                    orderId={orderEditId}
                    orderIndex={orderDetailIndex}
                    existingStatus={existingOrderStatus}
                    deleteSampleHandler={deleteSampleHandle}
                />
            }

            {isGeneralDetailModalOpen &&
                <GeneralDetailModal
                    onClose={() => setIsGeneralDetailModalOpen(false)}
                    open={isGeneralDetailModalOpen}
                    data={orderEditData}
                    isMetric={orderEditIsMetric}
                    sampleData={orderSampleEditData}
                    updateFunction={orderEditUpdateFunction}
                    orderId={orderEditId}
                    trackingNumbers={orderTrackingNumber}
                    trackingUrl={orderTrackingUrl}
                    labelUrl={orderUpsLabelUrl}
                />
            }

            {isGeneralLabelExportModalOpen &&
                <GeneralLabelModal
                    onClose={() => setIsGeneralLabelExportModalOpen(false)}
                    open={isGeneralLabelExportModalOpen}
                    data={generalLabelModalData}
                    isMetric={generalLabelIsMetric}
                    orderId={generalLabelOrderId}
                    exportFunction={handleShipmentExports}
                />
            }

            {isShipmentLabelDetailModalOpen &&
                <CreateShipmentLabelModal
                    onClose={() => setIsShipmentLabelDetailModalOpen(false)}
                    open={isShipmentLabelDetailModalOpen}
                    orderId={generalLabelOrderId}
                    requestLabel={handleCreateShipmentLabel}
                />
            }

            {isManuelShipmentLabelDetailModalOpen &&
                <CreateManuelShipmentLabelModal
                    onClose={() => setIsManuelShipmentLabelDetailModalOpen(false)}
                    open={isManuelShipmentLabelDetailModalOpen}
                    orderId={generalLabelOrderId}
                    requestLabel={handleManuelCreateShipmentLabel}
                />
            }

            {isDownloadModalOpen &&
                <PdfDownloadModal
                    open={isDownloadModalOpen}
                    pdfPageLayout={pdfPageLayout}
                    onClose={() => setDownloadModalOpen(false)}
                    pdfTitle={pdfTitle}
                />
            }
        </section>
    )
};

export default OrderDashboard;